exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkbox-question {\n  height: 25px;\n  width: 25px;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  -o-appearance: none;\n  appearance: none;\n  border: 1px solid #90cdf4;\n  border-radius: 4px;\n  outline: none;\n  transition-duration: 0.3s;\n  cursor: pointer;\n  position: relative;\n}\n.checkbox-question:checked {\n  border: 1px solid #90cdf4;\n}\n.checkbox-question:checked::before {\n  content: \"\";\n  position: absolute;\n  background-color: #90cdf4;\n  border-radius: 4px;\n  width: 15px;\n  height: 15px;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -52%);\n  transition: all 0.3s ease-in-out;\n}", ""]);

// exports
